import gql from 'graphql-tag';

export const _GET_PARTICIPANTS = gql`
	query gqlParticipantsGetParticipants($limit: Int = 10, $offset: Int = 0, $searchTerm: String) {
		risolto_participant(limit: $limit, offset: $offset, where: { name: { _ilike: $searchTerm } }) {
			name
			reference
		}
		risolto_participant_aggregate {
			aggregate {
				count
			}
		}
	}
`;

export const _GET_PARTICIPANT = gql`
	query gqlParticipantsGetParticipant($partRef: uuid!) {
		risolto_participant(where: { reference: { _eq: $partRef } }) {
			name
			reference
		}
	}
`;

export const _GET_PARTICIPANT_DETAILS = gql`
	query gqlParticipantsGetParticipantDetails($participant: uuid!) {
		participant: risolto_participant(where: { reference: { _eq: $participant } }) {
			name
			reference
			legal_entities {
				reference
				logical_id
				registration_name
				processing_details
			}
		}
	}
`;

export const _GET_PARTICIPANTS_BY_USER = gql`
query getParticipantsForUser($externalId: [String!], $license_module: risolto_platform_license_module_enum!) {
	risolto_participant(
	  where: {
		_and: [
		  {
			platform_participant_licenses: {
			  platform_license_module: { _eq: $license_module }
			}
		  },
		  {
			participant_users: {
			  person_by_reference: {
				external_id: { _in: $externalId }
			  }
			}
		  }
		]
	  }
	) {
	  logical_id
	  name
	  reference
	  user_interface_details
	  legal_entities {
		reference
		logical_id
		registration_name
		display_name
		single_sign_ons {
		  domain
		}
	  }
	  system_integrations(where: { external_system: { _eq: "AWS_QUICKSIGHT" } }) {
		external_system
		external_system_identifier
	  }
	}
  }
`;
